/* Ocederma landing sections — shared behaviour
   FAQ accordions, sticky CTA bar, click-to-play videos.
   Re-initialises safely inside the Shopify theme editor. */
(function () {
  'use strict';

  function initFaq(root) {
    root.querySelectorAll('[data-oc-faq]').forEach(function (faq) {
      if (faq.dataset.ocInit) { return; }
      faq.dataset.ocInit = '1';
      var multiple = faq.dataset.ocMultiple === 'true';
      faq.querySelectorAll('.oc-faq__header').forEach(function (header) {
        header.addEventListener('click', function () {
          var item = header.closest('.oc-faq__item');
          var willOpen = !item.classList.contains('is-open');
          if (!multiple) {
            faq.querySelectorAll('.oc-faq__item.is-open').forEach(function (other) {
              if (other !== item) {
                other.classList.remove('is-open');
                other.querySelector('.oc-faq__header').setAttribute('aria-expanded', 'false');
              }
            });
          }
          item.classList.toggle('is-open', willOpen);
          header.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
        });
      });
    });
  }

  function initSticky(root) {
    root.querySelectorAll('[data-oc-sticky]').forEach(function (bar) {
      if (bar.dataset.ocInit) { return; }
      bar.dataset.ocInit = '1';
      var after = parseInt(bar.dataset.ocAfter || '600', 10);
      function update() { bar.classList.toggle('is-visible', window.scrollY > after); }
      window.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  }

  function initVideos(root) {
    root.querySelectorAll('[data-oc-video]').forEach(function (wrap) {
      if (wrap.dataset.ocInit) { return; }
      wrap.dataset.ocInit = '1';
      var video = wrap.querySelector('video');
      if (!video) { return; }
      wrap.addEventListener('click', function (e) {
        if (video.controls && e.target === video) { return; }
        if (video.paused) { video.play(); } else { video.pause(); }
      });
    });
  }

  function init(root) { initFaq(root); initSticky(root); initVideos(root); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  /* theme editor hooks */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var item = e.target.closest ? e.target.closest('.oc-faq__item') : null;
    if (item && !item.classList.contains('is-open')) {
      item.classList.add('is-open');
      var h = item.querySelector('.oc-faq__header');
      if (h) { h.setAttribute('aria-expanded', 'true'); }
    }
  });
})();
